import { Lens } from 'monocle-ts'
import { ServerTask } from '../responses/tasks'
import { pipe } from 'fp-ts/es6/pipeable'
import * as array from 'fp-ts/es6/Array'
import { Project } from '../responses/projects'
import { ProjectWorkObject } from '../responses/objects'
import { FileData, TempFile } from '../responses/files'
import { User, UserWithTasks } from '../responses/users'
import { HistoryData } from '../responses/history'
import { Notification } from '../responses/notification'
import { DepartmentWithUsers } from '../responses/departments'
import { Comment } from '../responses/comments'

export const usersLens = Lens.fromProp<DepartmentWithUsers>()('users')
export const tasksLens = Lens.fromProp<UserWithTasks>()('tasks')
export const objectLens = Lens.fromProp<ServerTask>()('project_work_object')
export const projectLens = Lens.fromProp<ServerTask>()('project')
export const unsubscribedLens = Lens.fromProp<Project>()('unsubscribed_users')
export const existLens = Lens.fromProp<Project>()('dir_exists')

export const filesLens = Lens.fromProp<Project | ProjectWorkObject>()('files')

export const objectName = Lens.fromProp<ProjectWorkObject>()('name')
export const objectType = Lens.fromProp<ProjectWorkObject>()('work_object_type')
export const objectDesign = Lens.fromProp<ProjectWorkObject>()('design_status')
export const objectProduction = Lens.fromProp<ProjectWorkObject>()('production_status')

export const tempStatus = Lens.fromProp<TempFile>()('status')
export const tempFile = Lens.fromProp<TempFile<FileData>>()('data')

export const userDescription = Lens.fromProp<User>()('description')
export const departmentsTasks = (departments: DepartmentWithUsers[]): ServerTask[] => pipe(
    departments,
    array.map(usersLens.get),
    array.flatten,
    array.map(tasksLens.get),
    array.flatten,
)

export const historyRead = Lens.fromProp<HistoryData>()('read')
export const notificationRead = Lens.fromProp<Notification>()('read')

export const commentFiles = Lens.fromProp<Comment>()('files')